import { z } from 'zod'

// Владелец слота — сущность с документарной частью (документ владеть слотом
// не может: он сам живёт в слоте).
export const SLOT_ENTITY_KINDS = ['project', 'company', 'task', 'invoice', 'meeting'] as const
export const SlotEntityKindSchema = z.enum(SLOT_ENTITY_KINDS)
export type SlotEntityKind = z.infer<typeof SlotEntityKindSchema>

// Автор слота. У сотрудника id пуст (сотрудники не разделяются по слотам);
// у заказчика id — его customer-account (совпадает с session.id для «своего слота»).
export const SlotActorSchema = z.object({
  kind: z.enum(['employee', 'customer']),
  id: z.string().optional(),
})
export type SlotActor = z.infer<typeof SlotActorSchema>

// Слот документарной части сущности. Новые проекты получают 4 дефолтных слота
// при создании; остальные владельцы стартуют с нуля.
export const SlotSchema = z.object({
  id: z.string(),
  entity_kind: SlotEntityKindSchema,
  entity_id: z.string(),
  name: z.string(),
  ord: z.number(),
  customer_can_upload: z.boolean(),
  created_by: SlotActorSchema,
  version: z.number(),
})
export type Slot = z.infer<typeof SlotSchema>
